import { z } from 'zod';
export const BasicPluginHandlerResponse = z.object({
    element: z.object({}).nullable(),
    projectFiles: z.record(z.string()),
});
//# sourceMappingURL=basic-plugin.js.map